import React, { useEffect, useMemo } from 'react';
import { Drawer, Spin, Alert } from 'antd';
import { useLazyGetSourceByIdQuery } from '../../api';
import SourceInformation from './components/SourceInformation';
import MoveGroupInformation from './components/MoveGroupInformation';
import SourceInspection from './components/SourceInspection';
import PerformanceMetrics from './components/PerformanceMetrics';

const SourceDetailsDrawer = ({ open, onClose, sourceId, userOrg, preflightData }) => {
    const [fetchSource, { data: source, isLoading, isFetching, error }] = useLazyGetSourceByIdQuery();

    useEffect(() => {
        if (sourceId && open) {
            fetchSource(sourceId);
        }
    }, [sourceId, open, fetchSource]);

    const migrate_by_vm = useMemo(() => source?.collection_type === 'vm', [source?.collection_type]);

    if (error) {
        return (
            <Drawer title="Source Details" open={open} onClose={onClose} size={600} placement="right">
                <Alert title="Error Loading Source Details" description={error.message} type="error" showIcon />
            </Drawer>
        );
    }

    return (
        <Drawer title="" className={'source-details-drawer'} open={open} onClose={onClose} size={700} placement="right">
            {isLoading ? (
                <div className={'loading-screen'}>
                    <Spin size="large" />
                </div>
            ) : source ? (
                <div className={'drawer-content'}>
                    <SourceInformation source={source} isFetching={isFetching} />
                    <MoveGroupInformation moveGroup={source.move_group} isFetching={isFetching} />
                    <SourceInspection
                        migrate_by_vm={migrate_by_vm}
                        source={source}
                        isFetching={isFetching}
                        preflightData={preflightData}
                    />
                    <PerformanceMetrics source={source} />
                </div>
            ) : (
                <Alert
                    title="Source Not Found"
                    description="The requested source could not be found."
                    type="warning"
                    showIcon
                />
            )}
        </Drawer>
    );
};

export default SourceDetailsDrawer;
